import {inject} from 'aurelia-framework';
import {Router} from 'aurelia-router';
import {AuthService} from '../../services/authService';
import {UserMessageService} from '../../services/userMessageService';
import { AccountAdminAPI } from '../../services/admin/accountAdminAPI';

@inject(Router, AuthService, UserMessageService, AccountAdminAPI)
export class UserDashboard {
  constructor(router, authService, userMessageService, api) {
    this.api = api;
    this.router = router;
    this.authService = authService;
    this.userMessageService = userMessageService;
    this.captureKey == null;
    this.id = null;
    this.account = null;
    this.user = null;
   
  }

  activate(params) {
    console.log("window...",window);

    this.id = params.id;

   
  }

  attached() {

     this.load();

   
  }

  load() {
    this.api.getUserData(
      this.id,
      this.authService.getUser().token,
      this.saveLoadSuccess.bind(this),
      this.saveLoadError.bind(this));
  }

  saveLoadSuccess(data) {

   
    this.setData(data);

    let scriptElement = document.createElement('script');

    scriptElement.src = this.site_url + "/api/app/getLinkScript/" +  this.captureKey;


    this.scriptElementInHead = document.querySelector('#linkcode1').appendChild(scriptElement);
  }

  saveLoadError(msg) {
    this.userMessageService.setUserError('user', msg);
  }

  setData(data) {
    console.log("window...",window);
    this.account = data.account;
    this.user = data.user;

  
    this.captureKey = this.account.link_id;
    
    this.site_url = this.user.site_url;

    this.biz_url = data.account.biz_url;
    this.bizUrl = this.biz_url;

    var mlinkImg = this.user.whitelabel_id ? "/api/whitelabel/getFile?file=link_icon&t=" + new Date() :  '/images/magnfi-m.png';;

    let affiliateCount = this.account.affiliate_count;
    this.affiliateCountMessage = (affiliateCount === 1) ? 'You have 1 affiliate.' : `You have ${affiliateCount} affiliates.`;
    this.affiliateInfoLink = window.affiliate_info_url;
    this.affiliateTermsLink = window.affiliate_terms_url;
    this.showAffiliateCount = this.account.joined_affiliate_program !== null;
    this.requestCount = this.account.request_count;
    this.pendingRequests = this.account.pending_requests;
    this.acceptedRequests = this.account.accepted_requests;
    this.expiringRequests = this.account.expiring_requests;
    this.accountActive = this.account.status == '2';
    this.magnfiLink = this.site_url + '/biz/' + (data.account.biz_url ? data.account.biz_url : data.account.link_id);
    this.magnfiLinkImg = this.site_url + mlinkImg;
    this.magnfiLinkCode = "<p><a href='" + this.magnfiLink + "' target='_blank' rel='noopener noreferrer'><img src='" + this.magnfiLinkImg + "' style='max-width: 50px'/></a></p>";
    this.testimonial_expire_days = window.testimonial_expire_days;
    this.visitVideoReviewPageParam = data.account.biz_url ? data.account.biz_url : data.account.link_id;

  }

  saveBizUrl() {
    this.api.saveBizUrl(
      this.user.id,
      this.bizUrl,
      this.authService.getUser().token,
      () => { 
        
        this.userMessageService.setUserMessage('user', 'Custom URL Saved!'); 
        this.load(); 
      },
      this.saveLoadError.bind(this));
  }

  copyLinkCode1() {
    var code = " <span style='display: inline-block; border: solid 1px black; padding: 3px; font-family: Verdana, \"Lato\", sans-serif;'><a href='" + this.magnfiLink + "' rel='noopener noreferrer' target='_blank' style='text-decoration: none;'>See Our ";
    code += "<span style='display: inline-block; position: relative'><img src='" + this.magnfiLinkImg + "' style='max-width: 50px; vertical-align: middle; line-height: 1em; height: 50px;' />";
    code += "<span style='position: relative; top:-15px;display: inline-block; text-align: center; font-size: 10px; line-height: 1em; min-width: 10px; border: solid 2px black; border-radius: 25px; padding: 3px;'><span id='__m_pubvid_count'></span></span></span> Video Reviews</a></span>";
    code += "<script type='text/javascript' src='" + this.site_url + "/api/app/getLinkScript/" + this.link_id + "'></script>";
    
    this.copyTextToClipboard(code);
    this.userMessageService.setUserMessage('user', 'Copied!'); 
  }

  copyLinkCode2() {
    var code = "<span style='display: inline-block; border: solid 1px black; padding: 3px; font-family: Verdana, \"Lato/\", sans-serif;'><a href='" + this.magnfiLink + "' rel='noopener noreferrer' target='_blank' style='text-decoration: none;'>";
    code += "<img src='" + this.magnfiLinkImg + "' style='max-width: 50px; vertical-align: middle; line-height: 1em; height: 50px;' /> Leave a Video Review with " + this.app_name + "</a></span>";
  
    this.copyTextToClipboard(code);
    this.userMessageService.setUserMessage('user', 'Copied!'); 
  }

  copyBrandLink() {
    this.copyTextToClipboard(this.site_url + "/#/capture/brand/" + this.captureKey);
    this.userMessageService.setUserMessage('user', 'Copied!'); 
  }

  copyTextToClipboard(text) {
    if (!navigator.clipboard) {
      this.fallbackCopyTextToClipboard(text);
      return;
    }
    navigator.clipboard.writeText(text).then(function() {
      console.log('Async: Copying to clipboard was successful!');
    }, function(err) {
      console.error('Async: Could not copy text: ', err);
    });
  }

  fallbackCopyTextToClipboard(text) {
    var textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
  
    try {
      var successful = document.execCommand('copy');
      var msg = successful ? 'successful' : 'unsuccessful';
      console.log('Fallback: Copying text command was ' + msg);
    } catch (err) {
      console.error('Fallback: Oops, unable to copy', err);
    }
  
    document.body.removeChild(textArea);
  }

  uploadVideo() {
    this.router.navigate("#/capture/brand/" + this.captureKey + "?method=fileupload&uploadonly=1");
  }

  clickReviewPage() {
    this.api.updateVideoReviewPageAccessCount(this.visitVideoReviewPageParam,()=>{

    }, ()=> {

    });
    window.open(this.magnfiLink, "_blank");
  }

  clickShortReviewPage() {
    window.open(this.magnfiLink + "?short=true", "_blank");
  }

  copyShortReviewPage() {
    this.copyTextToClipboard(this.magnfiLink + "?short=true");
    this.userMessageService.setUserMessage('user', 'Copied!'); 
  }

  createBrandedVideo() {
    this.navigateLink('#/user/videos');
    window.open(window.site_url+"#/capture/brand/"+this.captureKey, "_blank");

    // href.bind="'#/capture/brand/' + captureKey"

  }
}
